"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutgoingMessage = exports.IncomingMessage = void 0;
var IncomingMessage;
(function (IncomingMessage) {
    IncomingMessage["APP_LOADED"] = "APP_LOADED";
    IncomingMessage["NAVIGATION"] = "NAVIGATION";
    IncomingMessage["AUTH_ERROR"] = "AUTH_ERROR";
    IncomingMessage["INITIALIZED"] = "INITIALIZED";
    IncomingMessage["EMIT_EVENT"] = "EMIT_EVENT";
})(IncomingMessage || (exports.IncomingMessage = IncomingMessage = {}));
var OutgoingMessage;
(function (OutgoingMessage) {
    OutgoingMessage["TOKEN_CHANGE"] = "TOKEN_CHANGE";
    OutgoingMessage["PROPERTY_CHANGE"] = "PROPERTY_CHANGE";
    OutgoingMessage["INITIALIZE_EMBED"] = "INITIALIZE_EMBED";
    OutgoingMessage["COLOR_SCHEME_CHANGE"] = "COLOR_SCHEME_CHANGE";
    OutgoingMessage["TRIGGER_EVENT"] = "TRIGGER_EVENT";
})(OutgoingMessage || (exports.OutgoingMessage = OutgoingMessage = {}));
